export class ApiClientError extends Error {
  constructor(
    message: string,
    public status: number,
    public code: string,
  ) {
    super(message)
    this.name = 'ApiClientError'
  }
}

export async function parseApiError(response: Response, fallback: string): Promise<ApiClientError> {
  const body = (await response.json().catch(() => null) ?? {}) as { message?: unknown; code?: unknown }
  return new ApiClientError(
    typeof body.message === 'string' ? body.message : fallback,
    response.status,
    typeof body.code === 'string' ? body.code : 'API_ERROR',
  )
}
